/**
 * {@link https://infra.spec.whatwg.org/#namespaces}
 *
 * @public
 */
export var Namespace;
(function (Namespace) {
    /**
     * {@link https://infra.spec.whatwg.org/#html-namespace}
     */
    Namespace["HTML"] = "http://www.w3.org/1999/xhtml";
    /**
     * {@link https://infra.spec.whatwg.org/#mathml-namespace}
     */
    Namespace["MathML"] = "http://www.w3.org/1998/Math/MathML";
    /**
     * {@link https://infra.spec.whatwg.org/#svg-namespace}
     */
    Namespace["SVG"] = "http://www.w3.org/2000/svg";
    /**
     * {@link https://infra.spec.whatwg.org/#xlink-namespace}
     */
    Namespace["XLink"] = "http://www.w3.org/1999/xlink";
    /**
     * {@link https://infra.spec.whatwg.org/#xml-namespace}
     */
    Namespace["XML"] = "http://www.w3.org/XML/1998/namespace";
    /**
     * @remarks
     * The trailing slash is not a typo! For some reason it snuck its way into the
     * specification and whether or not it is strictly required is an awfully good
     * question.
     *
     * {@link https://infra.spec.whatwg.org/#xmlns-namespace}
     */
    Namespace["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})(Namespace || (Namespace = {}));
/**
 * @public
 */
(function (Namespace) {
    function isNamespace(value) {
        switch (value) {
            case Namespace.HTML:
            case Namespace.MathML:
            case Namespace.SVG:
            case Namespace.XLink:
            case Namespace.XML:
            case Namespace.XMLNS:
                return true;
            default:
                return false;
        }
    }
    Namespace.isNamespace = isNamespace;
})(Namespace || (Namespace = {}));
//# sourceMappingURL=namespace.js.map